import BasicTabs from "modules/platform-components/basic-tabs/BasicTabs";
import React from "react";
import { ExamFilter } from "./filters";
import { tabList } from "./tablist";

export function ExamContent({
  fullQuestions,
  filteredSubject,
  setFilteredSubject,
  subjectValue,
  courses,
  courseValue,
  setCourseValue,
  tags,
  tagValue,
  setTagValue,
  topics,
  topicValue,
  setTopicValue,
  createdBy,
  setCreatedBy,
  approvedBy,
  setApprovedBy,
  complexity,
  setComplexity,
  users,
  showFilter,
  gridOptions,
  manualQuestions,
  showGrid,
  gridApi2,
  setManualQuestions,
  getSelectedExamInfo,
  setTabValue,
  setSearch,
  setIncludeQuestionsFromQB,
  setIssueReported,
  setCreatedDate,
  setUpdatedDate,
  setNumOfTimesUsedInExam
}) {

  return (
    <>
      {(fullQuestions.length > 0 ||
        filteredSubject.length > 0 ||
        tagValue.length > 0 ||
        topicValue.length > 0) && (
        <div>
          <ExamFilter
            showFilter={showFilter}
            filteredSubject={filteredSubject}
            setFilteredSubject={setFilteredSubject}
            subjectValue={subjectValue}
            courses={courses}
            courseValue={courseValue}
            setCourseValue={setCourseValue}
            tags={tags}
            tagValue={tagValue}
            setTagValue={setTagValue}
            topics={topics}
            topicValue={topicValue}
            setTopicValue={setTopicValue}
            createdBy={createdBy}
            setCreatedBy={setCreatedBy}
            approvedBy={approvedBy}
            setApprovedBy={setApprovedBy}
            complexity={complexity}
            setComplexity={setComplexity}
            users={users}
            setSearch={setSearch}
            setIncludeQuestionsFromQB={setIncludeQuestionsFromQB}
            setIssueReported={setIssueReported}
            setCreatedDate={setCreatedDate}
            setUpdatedDate={setUpdatedDate}
            setNumOfTimesUsedInExam={setNumOfTimesUsedInExam}

          />
          <div class="row" style={{ margin: "15px" }}>
            <div className="selected-items-div">
              <div className="selected-items-grid">
                  <BasicTabs
                    setTabValue={setTabValue}
                    tabList={tabList({
                      gridOptions,
                      manualQuestions,
                      fullQuestions,
                      showGrid,
                      gridApi2,
                      setManualQuestions,
                      status:
                        getSelectedExamInfo().status === "APPROVED" ||
                        getSelectedExamInfo().status === "PUSHED TO APP" ||
                        getSelectedExamInfo().status === "REJECTED",
                    })}
                  />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ExamContent;
